import {Component, ElementRef, forwardRef, Input, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-labeled-clearable-input',
    templateUrl: './labeled-clearable-input.component.html',
    styleUrls: ['./labeled-clearable-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => LabeledClearableInputComponent),
        multi: true
    }]
})
// copy of LabeledInputComponent from management-app
export class LabeledClearableInputComponent implements ControlValueAccessor {

    @Input()
    public decimals = 0;

    @Input()
    public textAlignLeft = false;

    @Input()
    public formatCurrency = false;

    @Input()
    public boldType = false;

    @Input()
    public name: string;

    @Input()
    public inputValue: string;

    @Input()
    public label: string;
    @Input()
    public placeholder: string;
    @Input()

    @Input()
    public type: 'number' | 'text';

    public maskValue: string;
    @Input()
    public showValidation: boolean;
    @Input()
    public isError: boolean;
    @Input()
    public disabled: boolean;
    @Input()
    public clearable: boolean;
    @Input()
    public minLength = 0;
    @Input()
    public maxLength = 99999999999;

    @ViewChild('inputRef') inputRef: ElementRef;

    public value = '';
    public onChange: (_: any) => void = (_: any) => {
    };
    public onTouched: () => void = () => {
    };

    public constructor() {
        if (!this.type) {
            this.type = 'text';
        }
        if ( this.inputValue?.length > 0) {
            this.value = this.inputValue;
        }
    }

    public showClearIcon(): boolean {
        return this.clearable; // && this.value && this.value.trim() !== '';
    }

    public clear(): void {
        this.value = '';
        this.updateChanges();
    }

    public updateChanges(): void {


        if (this.type === 'number' && !this.formatCurrency && this.value !== null && this.value !== undefined) {
            const newValue = this.value.toString().replace('.', '');
            if (+newValue > this.maxLength) {
                this.value = this.maxLength + '';
            }
        }
        this.onChange(this.value);
    }


    public writeValue(value: any): void {
        if (value !== this.name) {
            this.value = value;
        }
        this.updateChanges();
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }


    public limitDecimals(event, value: string) {
        if (value !== null && value !== undefined) {
            if (this.numberOnly(event)) {
                const splitted = value.toString().split('.');
                if (splitted[1] !== undefined) {
                    const decimals = splitted[1].slice(0, 5);
                    return splitted[0] + '.' + decimals;
                } else {
                    return value;
                }


            }
        }
        return value;
    }


    public minMax(event, value: string, min, max) {

        if (value !== null && value !== undefined && !this.formatCurrency) {

            if (this.numberOnly(event)) {

                const newValue = value.toString().replace('.', '');
                if (+newValue < min || isNaN(+newValue)) {
                    return null;
                } else if (+newValue >= max) {
                    return max;
                } else {
                    return +value;
                }

            }
        }
        return value;

    }

    public numberOnly(event): boolean {
        if (this.type === 'number') {
            const theEvent = event || window.event;
            let key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
            // tslint:disable-next-line:triple-equals
            if (key.length == 0) {
                return false;
            }

            let regex = /^[0-9\b]+$/;
            if (this.formatCurrency) {
                regex = /^[0-9.\b]+$/;
            }

            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) {
                    theEvent.preventDefault();
                }
                return false;
            }
        }
        return true;

    }

}
